module.exports = __webpack_public_path__ + "static/image/logo-family/logo_ceo@3x.png?6b68b1cf";